<template>
  <section>
    <div class="container pt-5 pb-5">
      <div class="columns is-vcentered">
        <div class="column is-6">
          <h1 class="title is-4 mb-0 has-text-primary has-text-centered-mobile">
            <span class="icon">
              <i class="mdi mdi-comment-account-outline"></i>
            </span>
            <span>TU PEDIDO</span>
          </h1>
        </div>
        <div class="column is-6 has-text-right has-text-centered-mobile"></div>
      </div>

      <section v-if="order">
        <div class="card">
          <div class="card-content">
            <h5 class="title is-5 has-text-primary">
              <span class="icon"><i class="mdi mdi-account"></i></span>
              <span>Contacto</span>
            </h5>

            <div class="p-3 has-background-light mb-3">
              Llena tu nombre, teléfono y correo electrónico. Asegúrate de
              <b>que tu correo sea correcto</b>, pues enviaremos la copia de tu
              pedido y notificaciones relevantes.
            </div>

            <div class="columns">
              <div class="column">
                <b-field
                  custom-class="has-text-primary"
                  label="Nombre completo"
                >
                  <b-input
                    required
                    v-model="payload.holder_name"
                    icon="account"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  custom-class="has-text-primary"
                  label="Teléfono de contacto"
                >
                  <b-input
                    required
                    v-model="payload.holder.phone"
                    icon="cellphone-sound"
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <b-field
                  custom-class="has-text-primary"
                  label="Correo electrónico"
                >
                  <b-input
                    type="email"
                    required
                    v-model="payload.holder.email"
                    icon="at"
                    @input="findHolder()"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field
                  custom-class="has-text-danger"
                  label="Confirma tu correo electrónico"
                >
                  <b-input
                    type="email"
                    required
                    v-model="payload.holder.email2"
                    icon="at"
                    @input="findHolder()"
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div v-if="emailsFilled">
              <b-notification
                :closable="false"
                v-if="emailsMatches === false"
                type="is-dark has-text-warning"
              >
                ¡Aún no coinciden el correo y la confirmación del correo!
              </b-notification>

              <b-notification
                :closable="false"
                v-else
                type="is-dark has-text-success"
              >
                <b-icon icon="check-circle-outline"></b-icon> ¡De acuerdo! Los
                correos son iguales.
              </b-notification>
            </div>

            <div v-if="order.shipping_method === 'standard'">
              <h5 class="title is-5 has-text-primary mt-5">
                <span class="icon"><i class="mdi mdi-map-marker"></i></span>
                <span>Dirección de Envío</span>
              </h5>

              <div class="p-3 has-background-light mb-3">
                Proporciona la dirección a donde deseas recibir tu pedido. Nos
                ayudas mucho especificando las entrecalles y alguna referencia
                para encontrarla más fácilmente.
              </div>

              <div class="columns">
                <div class="column is-6">
                  <b-field custom-class="has-text-primary" label="Calle">
                    <b-input
                      required
                      v-model="payload.address.street"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field
                    custom-class="has-text-primary"
                    label="Número Exterior"
                  >
                    <b-input required v-model="payload.address.ext"></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field
                    custom-class="has-text-primary"
                    label="Número Interior"
                  >
                    <b-input v-model="payload.address.int"></b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column is-6">
                  <b-field custom-class="has-text-primary" label="Colonia">
                    <b-input required v-model="payload.address.block"></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field
                    custom-class="has-text-primary"
                    label="Delegación o Municipio"
                  >
                    <b-input
                      required
                      v-model="payload.address.suburb"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field
                    custom-class="has-text-primary"
                    label="Código Postal"
                  >
                    <b-input v-model="payload.address.postal_code"></b-input>
                  </b-field>
                </div>
              </div>

              <div>
                <b-field
                  custom-class="has-text-primary"
                  label="¿Entre qué calles se encuentra?"
                >
                  <b-input
                    required
                    v-model="payload.address.ref_streets"
                  ></b-input>
                </b-field>
              </div>

              <div class="mt-3">
                <b-field
                  custom-class="has-text-primary"
                  label="Coméntanos algunas referencias para ubicar tu dirección"
                >
                  <b-input
                    type="textarea"
                    required
                    v-model="payload.address.references"
                  ></b-input>
                </b-field>
              </div>
            </div>

            <div class="field mt-5">
              <b-checkbox v-model="payload.terms_accept">
                <span class="has-text-primary">
                  Al hacer click en el botón <b><u>CONTINUAR</u></b> acepto los
                  <b><u>Términos y Condiciones</u></b> estipulados para el uso
                  de este sitio web, mismos que he leído.
                </span>
              </b-checkbox>
            </div>
          </div>
        </div>

        <div class="columns is-mobile mt-4">
          <div class="column is-6">
            <b-button
              type="is-dark"
              icon-left="arrow-left-bold"
              :disabled="isSyncing > 0"
              :loading="isSyncing > 0"
              @click="goTo(view_cart_url)"
            >
              REGRESAR
            </b-button>
          </div>
          <div class="column is-6 has-text-right">
            <b-button
              v-if="isValidInput && termsAccepted"
              type="is-primary"
              icon-right="arrow-right-bold"
              :disabled="isSyncing > 0"
              :loading="isSyncing > 0"
              @click="setOrderData()"
            >
              CONTINUAR
            </b-button>
            <span v-else>
              <b class="has-text-primary"
                ><u>Para poder continuar</u>: llena los campos requeridos y
                marcar la casilla para aceptar nuestros Términos y
                Condiciones.</b
              >
            </span>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
import CartApi from "@/api/cart";

export default {
  name: "FillData",
  mixins: [AppMappers, CartApi],
  props: ["order_data", "view_cart_url"],
  data() {
    return {
      order: null,
      isSyncing: 0,
      isSearching: false,
      hasError: false,
      postal_code: "",
      shipping_details: "",
      payment_provider: null,

      empty_payload: {
        holder_name: "",
        holder: {
          phone: "",
          email: "",
          email2: "",
        },
        address: {
          street: "",
          ext: "",
          int: "",
          block: "",
          suburb: "",
          city: "",
          postal_code: "",
          ref_streets: "",
          references: "",
          ref_person: "",
        },

        terms_accept: false,
      },

      payload: {
        holder_name: "",
        holder: {
          phone: "",
          email: "",
          email2: "",
        },
        address: {
          street: "",
          ext: "",
          int: "",
          block: "",
          suburb: "",
          city: "",
          postal_code: "",
          ref_streets: "",
          references: "",
          ref_person: "",
        },

        terms_accept: false,
      },
    };
  },

  created() {
    this.order = this.order_data;
    this.postal_code = this.$storage.get("order_postal_code", "");
    this.payment_provider = this.$storage.get("order_payment_provider", null);
    this.payload = this.$storage.get("order_payload", this.empty_payload);

    let shipping_details = this.$storage.get("shipping_details", null);

    if (shipping_details) {
      let match;

      if (shipping_details.matches[shipping_details.selected_index]) {
        match = shipping_details.matches[shipping_details.selected_index];
        if (match) {
          this.payload.address.block = match.asentamiento;
          this.payload.address.suburb = match.municipio;
          this.payload.address.city = match.estado;
          this.payload.address.postal_code = match.codigo;
        }
      }
    }
  },

  computed: {
    total_items() {
      return Object.keys(this.order.items).length;
    },
    emailsFilled() {
      return (
        this.payload.holder.email.length && this.payload.holder.email2.length
      );
    },
    emailsMatches() {
      if (
        this.payload.holder.email.length === 0 &&
        this.payload.holder.email2.length === 0
      ) {
        return true;
      }

      return this.payload.holder.email === this.payload.holder.email2;
    },
    isValidInput() {
      let isValid = true;

      if (this.payload.holder_name.length === 0) {
        isValid = false;
      }

      if (
        this.payload.holder.phone.length === 0 ||
        this.payload.holder.email.length === 0 ||
        this.payload.holder.email2.length === 0
      ) {
        isValid = false;
      }

      if (this.order.shipping_method === "standard") {
        if (
          this.payload.address.street.length === 0 ||
          this.payload.address.ext.length === 0 ||
          this.payload.address.block.length === 0 ||
          this.payload.address.suburb.length === 0 ||
          this.payload.address.city.length === 0 ||
          this.payload.address.postal_code.length === 0 ||
          this.payload.address.ref_streets.length === 0 ||
          this.payload.address.references.length === 0
        ) {
          isValid = false;
        }
      }

      return isValid;
    },

    termsAccepted() {
      let isTermsAccepted = true;

      if (this.payload.terms_accept === false) {
        isTermsAccepted = false;
      }
      return isTermsAccepted;
    },
  },

  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.setCartStep("data");
    });
  },

  methods: {
    goTo(path) {
      let self = this;
      self.isSyncing++;
      window.location.replace(path);
    },

    findHolder() {
      let self = this;
      if (this.emailsFilled && this.emailsMatches) {
        this.api_filtered(
          "find_holder",
          { email: self.payload.holder.email },
          (response) => {
            if (response) {
              console.log("[LOG] findHolder Response", response);
              if (response.holder_exists) {
                let holder = response.holder;
                return this.$buefy.dialog.confirm({
                  type: "is-success",
                  hasIcon: true,
                  message: `
                    <b>¡Hola de nuevo ${holder.name}!</b> <br> 
                    ¿Dado que ya has comprado en nuestra tienda, deseas que llenemos tus datos guardados?. <br>
                  `,
                  cancelText: "No, gracias",
                  confirmText: "¡Adelante!",
                  onConfirm: () => {
                    self.payload.holder_name = holder.name;
                    self.payload.holder.phone = holder.phone;

                    if (holder.address) {
                      self.payload.address.street = holder.address.street;
                      self.payload.address.ext = holder.address.ext;
                      self.payload.address.int = holder.address.int;
                      self.payload.address.block = holder.address.block;
                      self.payload.address.suburb = holder.address.suburb;
                      self.payload.address.postal_code =
                        holder.address.postal_code;
                      self.payload.address.ref_streets =
                        holder.address.ref_streets;
                      self.payload.address.references =
                        holder.address.references;
                    }
                  },
                });
              }
            }
          }
        );
      }
    },

    getOrder() {
      let self = this;
      self.isSyncing++;
      self.api_get("get_order", (response) => {
        self.order = response.order;
        self.isSyncing--;
        self.fireCartChange({
          item_count: self.total_items,
          order_total: self.order.total,
        });
        self.getShippingDetails();
      });
    },

    setOrderData() {
      let self = this;
      self.isSyncing++;
      this.payload.payment_provider = this.$storage.get(
        "order_payment_provider",
        null
      );
      self.api_post("set_order_data", this.payload, (response) => {
        self.isSyncing--;
        self.goTo(response.url);
      });
    },
  },
  watch: {
    payload: {
      deep: true,
      handler() {
        this.$storage.set("order_payload", this.payload);
      },
    },
  },
};
</script>